export const SHOW_SETTINGS_EVENT = 'SHOW_SETTINGS_EVENT'
